export default {
  label: {
    filter: 'owned and earned posts',
  },
};
